import { useForm } from "@pankod/refine-react-hook-form";
import { Edit, Box, TextField, Grid } from "@pankod/refine-mui";

export const SupplierEdit: React.FC = () => {
  const {
    refineCore: { formLoading },
    saveButtonProps,
    register,
    formState: { errors },
  } = useForm();

  return (
    <Edit isLoading={formLoading} saveButtonProps={saveButtonProps}>
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              {...register("name", { required: "Nombre es obligatorio" })}
              error={!!errors?.name}
              helperText={errors.name?.message?.toString()}
              margin="normal"
              required
              fullWidth
              id="name"
              label="Nombre"
              name="name"
              autoFocus
              defaultValue={" "}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              {...register("phone")}
              error={!!errors?.phone}
              helperText={errors.phone?.message?.toString()}
              margin="normal"
              fullWidth
              id="phone"
              label="Teléfono"
              name="phone"
              defaultValue={" "}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              {...register("email", {
                required: "Correo es obligatorio",
                validate: (value) => {
                  return value?.includes("@") || "Correo no válido";
                },
              })}
              error={!!errors?.email}
              helperText={errors.email?.message?.toString()}
              margin="normal"
              fullWidth
              id="email"
              label="Correo"
              name="email"
              defaultValue={" "}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              {...register("address")}
              error={!!errors?.address}
              helperText={errors.address?.message?.toString()}
              margin="normal"
              fullWidth
              id="address"
              label="Dirección"
              name="address"
              defaultValue={" "}
            />
          </Grid>
        </Grid>
      </Box>
    </Edit>
  );
};
